
<template>
    <div class="signal-checkbox" @mouseover="sourceHover" @mouseleave="sourceLeave" >
      <el-tooltip class="item" effect="dark" :content="signalText" placement="right-start">
        <span @dblclick="(event)=>dbClick(event,signalKey)">
                  {{simpleText}}</span>
      </el-tooltip>
      <i class="el-icon-close" v-show="deleteShow" @click="deleteSignalKey"></i>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'signal-source-checkbox',
  computed: {
    ...mapState('Engineering', ['treeConfigData', 'treeDatabase', 'leftStructure']),
    dataAll() {
      console.log('data', this.leftStructure);
      return this.treeConfigData;
    },
    simpleText() {
      if (this.signalText.substring(this.signalText.lastIndexOf('.') + 1).length < 20) {
        return this.signalText.substring(this.signalText.lastIndexOf('.') + 1);
      }
      return `${this.signalText.substring(this.signalText.lastIndexOf('.') + 1).substring(0, 20)} ...`;
    },
  },
  props: {
    signalKey: {
      type: String,
    },
    // 信号源名字
    signalText: {
      type: String,
    },
    // dataSource的key
    detailIndex: {
      type: Number,
    },
    // 当前组件的key
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      checkStatus: true,
      deleteShow: false,
      queryDeviceName: '',
      queryDeviceCan: '',
    };
  },
  methods: {
    ...mapMutations('Engineering', ['setSignalSourceDetailIndex', 'deleteSignalSourceDetailIndex', 'setAnchorPointId', 'setAnchorKeyWord']),
    sourceHover() {
      this.deleteShow = true;
    },
    sourceLeave() {
      this.deleteShow = false;
    },
    deleteSignalKey() {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      // console.log(this.componentIndex, this.detailIndex);
      this.deleteSignalSourceDetailIndex({
        componentIndex: this.componentIndex,
        detailIndex: this.detailIndex,
        signalKey: this.$props.signalKey,
      });
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
  },
};
</script>

<style lang="scss">
    .signal-checkbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 150px;
        margin-top: 10px;
        height: 24px;
        line-height: 24px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 15px;
        background: #ddd;

        &.hidden {
            display: none;
        }

        .el-checkbox {
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 26px;

            .el-checkbox__label {
                font-size: 12px;
                /*font-weight:0;*/
            }
        }

        i {
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/engineering/SignalSourceCheckbox.vue